import { FaStar } from "react-icons/fa";
import React from 'react'
import { ListStarWrapper } from './styled.js'

function ListStar({ star }) {
    const arr = [1, 2, 3, 4, 5]
    return (
        <ListStarWrapper>
            <ul className='list_star'>
                {
                    arr.map((item, index) => (
                        <li className='list_star_item' key={index}>
                            <FaStar
                                className={`list_star_item_icon ${star >= item ? "text-red-2" : ""}`}
                            />
                        </li>
                    ))
                }
            </ul>
        </ListStarWrapper>
    )
}

export default ListStar